module.exports = __webpack_public_path__ + "static/icon-temporary-dwellings-480px-34af0a8beaae28f33b5fce9cb0948739.png";